import { ButtonDropdown, DropdownMenu } from 'reactstrap';
import styled from 'styled-components';

export const WideButtonDropdown = styled(ButtonDropdown).attrs({
  className: 'w-100'
})`
  .dropdown-toggle::after {
    float: right;
    margin-top: 0.875rem;
  }
`;

export const WideDropdownMenu = styled(DropdownMenu).attrs({
  className: 'w-100'
})``;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/SubjectDropdown/SubjectDropdown.style.js